import { Telemetry } from "app/services/telemetry/Telemetry";
import {
  DEFAULT_QUESTIONNAIRE_ANSWER_TYPE,
  IQuestionnaireQuestionRaw,
  isQuestionnaireAnswerType,
  QuestionnaireAnswerType,
  QuestionnaireQuestionOption,
  QuestionnaireStepQuestion,
} from "./types";

const getNormalizedAnswerType = (
  answerType: string,
  question: Pick<IQuestionnaireQuestionRaw, "id" | "question_key">
): QuestionnaireAnswerType => {
  if (isQuestionnaireAnswerType(answerType)) {
    return answerType;
  }

  Telemetry.eventOnce(`[questionnaire] Unsupported answer_type "${answerType}"`, {
    domain: 'questionnaire',
    reason: `Unsupported answer_type "${answerType}"`,
    fallback: DEFAULT_QUESTIONNAIRE_ANSWER_TYPE,
    source: `${question.question_key} (${question.id})`,
  });

  return DEFAULT_QUESTIONNAIRE_ANSWER_TYPE;
};

export const normalizeQuestionOptions = (options?: Array<{
  id?: string;
  order: number;
  label: string;
  value: string | number;
  is_other?: boolean;
}>): QuestionnaireQuestionOption[] => {
  if (!options) {
    return [];
  }

  return [...options]
    .sort((a, b) => a.order - b.order)
    .map((option) => ({
      id: option.id,
      order: option.order,
      label: option.label,
      value: String(option.value),
      is_other: option.is_other,
    }));
};

export const serializeRawQuestion = (question: IQuestionnaireQuestionRaw): QuestionnaireStepQuestion => {
  const answerType = getNormalizedAnswerType(question.answer_type, {
    id: question.id,
    question_key: question.question_key,
  });

  return {
    id: question.id,
    question_key: question.question_key,
    text: question.text,
    order: question.order,
    answer_type: answerType,
    mandatory: question.mandatory,
    options: normalizeQuestionOptions(question.options),
  };
};


